$(document).ready(function() {
  const benefitsItem = $('.product-benefits-item');
  const benefitsLink = $('.product-benefits-link');
  const benefitsAccordion = $('.product-benefits-accordion');

  // Add hover images (keeping your existing hover functionality)
  benefitsItem.each(function(index) {
    let imageUrl = $(this).data('image');
    $(this).append(`<img class="product-benefits-image" data-benefit="${index}" src="${imageUrl}" alt="">`);
    $(this).attr('data-global-index', index);
  });

  // Hover functionality for the floating images
  benefitsLink.on('mouseover', function(e) {
    let index = $(this).closest('.product-benefits-item').attr('data-global-index');
    let $image = $(`.product-benefits-image[data-benefit="${index}"]`);
    let $accordion = $(this).closest('.product-benefits-item').find('.product-benefits-accordion');
    
    // Only show hover image if accordion is not open
    if (!$accordion.is(':visible')) {
      $image.addClass('active').css({
        transform: `translate(${e.clientX + 30}px, ${e.clientY - 90}px)`,
        opacity: '1'
      });
    }
  }).on('mousemove', function(e) {
    let index = $(this).closest('.product-benefits-item').attr('data-global-index');
    let $image = $(`.product-benefits-image[data-benefit="${index}"]`);
    let $accordion = $(this).closest('.product-benefits-item').find('.product-benefits-accordion');

    // Only update position if accordion is not open
    if (!$accordion.is(':visible')) {
      $image.css({
        transform: `translate(${e.clientX + 30}px, ${e.clientY - 90}px)`,
        opacity: '1'
      });
    }
  }).on('mouseout', function(e) {
    $('.product-benefits-image').removeClass('active').css('opacity', '0');
  });

  // Accordion click functionality with slideToggle
  benefitsLink.on('click', function(e) {
    e.preventDefault();
    
    const $clickedItem = $(this).closest('.product-benefits-item');
    const $clickedAccordion = $clickedItem.find('.product-benefits-accordion');
    const isCurrentlyOpen = $clickedAccordion.is(':visible');
    
    // Close all other accordions first
    benefitsAccordion.not($clickedAccordion).slideUp(400);
    
    // Toggle the clicked accordion
    if (!isCurrentlyOpen) {
      $clickedAccordion.slideDown(400);
    } else {
      $clickedAccordion.slideUp(400);
    }
    
    return false;
  });

  // Close accordion when clicking outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.product-benefits-item').length) {
      benefitsAccordion.slideUp(400);
    }
  });

  // Keyboard support for accessibility
  benefitsLink.on('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(this).click();
    }
  });

  // Close with Escape key
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') {
      benefitsAccordion.slideUp(400);
    }
  });
});